import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";


@Component({
    selector: 'page-progress-report',
    templateUrl: 'progress-report.html',
})
export class ProgressReportPage {

    ProgressData: any;
    AllSorceData: any;

    constructor(public navCtrl: NavController,
                public service: ServiceProvider,
                public viewCtrl: ViewController,
                public loadingCtrl: LoadingController,
                public platform: Platform,
                public navParams: NavParams) {

        this.platform.ready().then(() => {
            this.loadvalues();
            console.log('ionViewDidLoad ProgressReportPage');
        });

    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad ProgressReportPage');
    }


    loadvalues() {

        let loading = this.loadingCtrl.create({
            content: 'Please wait...'
        });

        loading.present();

        this.ProgressData = [];
        this.AllSorceData = [];
        this.service.httpcall('app_web_service/get_progress?').subscribe(data => {

            this.ProgressData = data;
            this.AllSorceData = data['Data']['Sub_ststus'];
            console.log('AllSorceData',this.AllSorceData);
            loading.dismiss();
        })
    }

    doRefresh(refresher) {
        console.log('Begin async operation', refresher);

        this.loadvalues();

        setTimeout(() => {
            console.log('Async operation has ended');

            refresher.complete();
        }, 2000);
    }

    backBTN() {
        this.viewCtrl.dismiss();
    }


}



// WEBPACK FOOTER //
// ./src/pages/progress-report/progress-report.ts